import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=7160379a&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=7160379a&prod&lang=scss&"
import style1 from "./UserForm.vue?vue&type=style&index=1&id=7160379a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160379a",
  null
  
)

export default component.exports